module.exports = __webpack_public_path__ + "img/make_repair.7a35b5c1.svg";